import React from 'react'
import ReactTooltip from 'react-tooltip'

interface IButton {
  handleClick: () => void
  path: string
}
export default function Pause({handleClick, path}: IButton) {
  const [play, setIsPLaying] = React.useState(false)
  return (
    <>
      <div
        onClick={() => {
          handleClick()
          setIsPLaying(current => !current)
        }}
        className=" cursor-pointer flex items-center justify-center self-center"
        data-tip
        data-for="playPause"
      >
        <svg
          className=" w-7 h-7"
          fill="#ffffff"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path d={path} />
        </svg>
      </div>
      <ReactTooltip id="playPause" place="top" effect="solid">
        {play ? 'Pause' : 'Play'}
      </ReactTooltip>
    </>
  )
}
